import React from 'react';
import { Box } from '@mui/material';
import PropTypes from 'prop-types';
import InterestBalanceScheduleTable from '../InterestBalanceSchedule/InterestBalanceScheduleTable';

const FiscalInterestBalanceSchedule = ({ interestBalanceSchedule }) => {
  return (
    <Box mt={3}>
      <InterestBalanceScheduleTable
        interestBalanceSchedule={interestBalanceSchedule}
      />
    </Box>
  );
};

FiscalInterestBalanceSchedule.propTypes = {
  interestBalanceSchedule: PropTypes.array
};

export default FiscalInterestBalanceSchedule;


